import React from "react";
import XGSFormCheckbox from "ui-components/form/checkbox/xgsFormCheckbox";
import { useFormikContext } from "formik";
import { AddEditAddress } from "app/data/address-manager/models";
import XGSFormInput from "ui-components/form/input/xgsFormInput";
import { LabelModes } from "ui-components/molecules/labeled-inputs/labeledInput";

export default function OperationalRequirements() {
    const { values } = useFormikContext<AddEditAddress>();
    return (
        <>
            <div>
                <div className="add-edit-address-section__row-item no-gap">
                    <XGSFormCheckbox
                        mix="xgs-invite-user__popup__checkbox"
                        name="hasDock"
                    >
                        Has Dock
                    </XGSFormCheckbox>
                    <XGSFormCheckbox
                        mix="xgs-invite-user__popup__checkbox"
                        name="limitedAccess"
                        checked={values?.limitedAccess || values?.locationType === "Limited Access"}
                    >
                        Limited Access
                    </XGSFormCheckbox>
                </div>
                <div className="add-edit-address-section__row-item no-gap">
                    <XGSFormCheckbox
                        mix="xgs-invite-user__popup__checkbox"
                        name="gateCodeRequired"
                    >
                        Gate Code Required
                    </XGSFormCheckbox>
                </div>
                {values?.gateCodeRequired && (
                    <div className="add-edit-address-section__row-item__indented">
                        <div className="add-edit-address-section__row-item no-gap">
                            <XGSFormInput
                                type="text"
                                name="gateCode"
                                labelMode={LabelModes.column}
                                label="Gate Code"
                            />
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
